import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import {
  chinaContract,
  tokenRegistryContract,
} from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const WbtcPrice = () => {
  const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress = Environment.tokenRegistry;
  const contract = tokenRegistryContract(tokenAddress, web3);

  const wbtcPrice = useCallback(async () => {
    try {
      const buy = await contract.methods
        .getLatestPrice(Environment.wbtc)
        .call();
      // console.log(buy[0]/10**8,"buy");
      return buy[0] / 10 ** 8;
    } catch (error) {
      throw error;
    }
  }, [contract, account, web3]);
  return { wbtcPrice: wbtcPrice };
};
export default WbtcPrice;
